// @flow

import React from 'react';
import { observer } from 'mobx-react-lite';

import styled from '@emotion/styled';
import { css } from 'emotion';

import FontAwesome from '@vromo/ui/components/FontAwesome';

export const Card = styled.div`
    display: flex;
    flex: 1;
    flex-shrink: 0;
    padding: 10px 10px;
    margin: 5px 20px;
    justify-content: space-around;
    align-content: center;
    background: #ffffff;
    box-shadow: 0 2px 5px 1px rgba(217, 217, 217, 0.5);
    border-radius: 8px;
    text-align: center;
`;

interface Props {
    icon: string;
    colour: string;
    quantity: string | number;
    label: string;
}

export const InfoCard = observer<Props>(function InfoCard({ icon, colour, quantity, label }) {
    return (
        <Card>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flex: 2
                }}>
                <FontAwesome
                    icon={icon}
                    weight="regular"
                    className={css`
                        font-size: 3.5em;
                        color: ${colour};
                    `}
                />
            </div>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    flex: 3
                }}>
                <div>
                    <h1 style={{ fontSize: '2em', marginBottom: 0 }}>{quantity}</h1>
                </div>
                <div>
                    <h3 style={{ marginTop: 0, fontWeight: 300 }}>{label}</h3>
                </div>
            </div>
        </Card>
    );
});
